import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class RowTypeField extends BaseOption {
  static userInterfaceComponent = {
    label: "Row type field",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "";
}
